module.exports = __webpack_public_path__ + "img/logo.8d03a8fa.svg";